/**
 * Utility functions for environment detection
 */

/**
 * Check if the current environment is production
 * @returns true if in production environment
 */
export function isProductionEnvironment(): boolean {
    const keycloakRealm = import.meta.env.VITE_APP_KEYCLOAK_REALM;
    return keycloakRealm === 'prod';
}

/**
 * Check if text management features should be available
 * Text management features (TextMaintenance, TextDiffs) are not available in production
 * @returns true if text management features should be shown
 */
export function isTextManagementAvailable(): boolean {
    return !isProductionEnvironment();
}